/**
 * heroes sprite atlas — GENERATED, do not edit.
 *
 *   Blender --background --python tools/blender/build_items.py -- --atlas
 *   Blender --background --python tools/blender/pack_atlas.py -- ...
 *   node tools/build-item-atlas.mjs
 *
 * Frame coordinates into `/heroes.webp`, rendered from the 3 cave-visible poses (walk_a, walk_b, swing) in `build_characters.py`, packed by `pack_atlas.py` at a larger cell than the other sheets — this is the one sprite a player looks at for a whole run.
 * One sheet is one request: on a slow connection, separate icons cost far more
 * than the icons' worth of bytes.
 */
export const HERO_URL = '/heroes.webp';
export const HERO_CELL = 256;
export const HERO_SIZE = { width: 1536, height: 768 } as const;

export interface GearFrame {
  x: number;
  y: number;
}

const FRAMES: Readonly<Record<string, GearFrame>> = {
  "poses/character_jin_swing": { x: 0, y: 0 },
  "poses/character_jin_walk_a": { x: 256, y: 0 },
  "poses/character_jin_walk_b": { x: 512, y: 0 },
  "poses/character_luna_swing": { x: 768, y: 0 },
  "poses/character_luna_walk_a": { x: 1024, y: 0 },
  "poses/character_luna_walk_b": { x: 1280, y: 0 },
  "poses/character_mira_swing": { x: 0, y: 256 },
  "poses/character_mira_walk_a": { x: 256, y: 256 },
  "poses/character_mira_walk_b": { x: 512, y: 256 },
  "poses/character_rocky_swing": { x: 768, y: 256 },
  "poses/character_rocky_walk_a": { x: 1024, y: 256 },
  "poses/character_rocky_walk_b": { x: 1280, y: 256 },
  "poses/character_sakura_swing": { x: 0, y: 512 },
  "poses/character_sakura_walk_a": { x: 256, y: 512 },
  "poses/character_sakura_walk_b": { x: 512, y: 512 },
  "poses/character_thor_swing": { x: 768, y: 512 },
  "poses/character_thor_walk_a": { x: 1024, y: 512 },
  "poses/character_thor_walk_b": { x: 1280, y: 512 },
};

/**
 * Frame for a key, or null when the sheet has no art for it.
 *
 * Null rather than a placeholder frame is deliberate: something added before
 * its model is rendered should fall back to its emoji, not draw whatever
 * happens to sit at (0, 0).
 */
export function heroFrame(key: string): GearFrame | null {
  return FRAMES[key] ?? null;
}

export const HERO_KEYS = Object.keys(FRAMES);
